import { Combinatorics, MGPOptional } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { GipfProjectHelper } from '../../jscaip/GipfProjectHelper';
import { YinshCapture, YinshMove } from './YinshMove';
import { YinshPiece } from './YinshPiece';
import { YinshRules } from './YinshRules';
export class YinshMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const moves = [];
        const state = node.gameState;
        if (state.isInitialPlacementPhase()) {
            for (const { coord, content } of state.getCoordsAndContents()) {
                if (content === YinshPiece.EMPTY) {
                    moves.push(new YinshMove([], coord, MGPOptional.empty(), []));
                }
            }
        }
        else {
            const rules = YinshRules.get();
            this.getPossibleCaptureCombinations(state)
                .forEach((initialCaptures) => {
                const stateAfterCapture = rules.applyCaptures(initialCaptures, state);
                this.getRingMoves(stateAfterCapture).forEach((ringMove) => {
                    const stateAfterRingMove = rules.applyRingMoveAndFlip(ringMove.start, ringMove.end, stateAfterCapture);
                    this.getPossibleCaptureCombinations(stateAfterRingMove)
                        .forEach((finalCaptures) => {
                        const move = new YinshMove(initialCaptures, ringMove.start, MGPOptional.of(ringMove.end), finalCaptures);
                        moves.push(move);
                    });
                });
            });
        }
        return moves;
    }
    getPossibleCaptureCombinations(state) {
        const rules = YinshRules.get();
        const possibleCaptures = rules.getPossibleCaptures(state);
        const ringCoords = this.getRingCoords(state);
        return GipfProjectHelper.getPossibleCaptureCombinationsFromPossibleCaptures(possibleCaptures)
            .map((captureCombination) => {
            return Combinatorics.getCombinations(ringCoords, captureCombination.length)
                .map((ringsTaken) => {
                return captureCombination.map((capture, index) => {
                    return new YinshCapture(capture.capturedSpaces, MGPOptional.of(ringsTaken[index]));
                });
            });
        }).reduce((accumulator, captures) => {
            return accumulator.concat(captures);
        }, []);
    }
    getRingMoves(state) {
        const rules = YinshRules.get();
        const moves = [];
        for (const start of this.getRingCoords(state)) {
            for (const end of rules.getRingTargets(state, start)) {
                moves.push({ start, end });
            }
        }
        return moves;
    }
    getRingCoords(state) {
        const player = state.getCurrentPlayer();
        const coords = [];
        state.forEachCoord((coord, content) => {
            if (content === YinshPiece.RINGS.get(player)) {
                coords.push(coord);
            }
        });
        return coords;
    }
}
